<template>
    <b-row :class="{'isCareerEntrep': isJACareerEntrepreApp}">
        <b-col v-if="!form.image" cols="12" class="text-center mt-3">
            <input type="file" class="d-none" @change="onFileChangeCompress"
                   accept="image/x-png,image/jpeg" ref="uploadInput" />
            <b-button v-if="isOnline" block class="mt-2" variant="primary" @click="clickUpload">
                Upload Photo
            </b-button>
        </b-col>
        <b-col cols="12">
            <div class="content-image">
                <img v-if="form.image" class="upload-image" :src="form.image" tabindex="0" alt="user uploaded image"/>
                <button v-if="isOnline && form.image" class="delete-image btn" @click="removeImage" aria-label="delete image">X</button>
                <div v-if="isOffline" class="content-image-inside" :class="{overlay:form.image}" >
                    <span class="icon icon-offline"></span>
                    <span class="content-image-inside-text">You have to be online to view this content</span>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>

    import { Project, Storage } from "../Utils";

    export default {
        name: "UploadImage",
        projectId: {
            type: [String, Number],
            required: true
        },
        step: {
            type: String,
            required: true
        },
        data() {
            return {
                form: {
                    projectId: this.projectId,
                    keyStep: this.step,
                    image: null
                }
            }
        },
        props: {
            projectId: {
                type: [String, Number],
                required: true
            },
            step: {
                type: String,
                required: true
            },
            maxWidth: {
                type: Number,
                default: 600
            },
            maxHeight: {
                type: Number,
                default: 600
            }
        },
        mounted() {
            if (this.isGuest) {
                const {_, image} = Storage.getProjectImage(this.projectId, this.step)
                if (image) {
                    this.form.image = image.image
                }
            } else if (this.isOnline && !this.form.image && !this.isGuest) {
                Project.getProjectImage(this.projectId, this.step).then(image => {
                    this.form.image = image
                }).catch(error =>{
                    this.form.image = null;
                })
            }
        },
        methods: {
            clickUpload() {
                this.$refs.uploadInput.click()
            },
            onFileChangeCompress(e) {
                const files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    return
                }
                const reader = new FileReader()
                reader.onload = event => {
                    const img = new Image()
                    img.src = event.target.result
                    img.onload = () => {
                        let width = img.width
                        let height = img.height
                        const widthDiff = img.width - this.maxWidth
                        const heightDiff = img.height - this.maxHeight
                        if (widthDiff > 0 || heightDiff > 0) {
                            const ratio = img.width / img.height
                            if (widthDiff > heightDiff) {
                                width = this.maxWidth
                                height = Math.round(this.maxWidth / ratio)
                            } else {
                                height = this.maxHeight
                                width = Math.round(this.maxHeight * ratio)
                            }
                        }
                        const elem = document.createElement('canvas')
                        elem.width = width
                        elem.height = height
                        const ctx = elem.getContext('2d')
                        ctx.drawImage(img, 0, 0, width, height)
                        this.form.image = ctx.canvas.toDataURL('image/jpeg', 1);

                        if (this.isGuest) {
                            Storage.saveProjectImage(this.form.projectId, this.form.keyStep, this.form.image)
                        } else if (this.isOnline) {
                            Project.saveProjectImage(this.form.projectId, this.form.keyStep, this.form)
                        }
                    }
                }
                reader.readAsDataURL(files[0])
            },
            removeImage() {
                this.form.image = ''
                if (this.isGuest) {
                    Storage.saveProjectImage(this.form.projectId, this.form.keyStep, this.form.image)
                } else if (this.isOnline) {
                    Project.saveProjectImage(this.form.projectId, this.form.keyStep, this.form)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .content-image
        position relative
        margin-top 1rem

        &-inside
            display flex
            justify-content center
            align-items center
            flex-direction column
            background-color rgba(color-7, 0.85)
            min-height 200px

            &.overlay
                position absolute
                height 100%
                width 100%
                top 0
                left 0

            .icon
                width 57px
                height 48px

            &-text
                width 65%
                text-align center
                padding-top 10px

        img
            border-radius 0

    .high-contrast
        .delete-image
            background-color color-29

    .upload-image
        border-radius 5px
        max-width 100%

    .delete-image
        position absolute
        top: 20px
        right: -20px
        width 40px
        height 40px
        transform(translate(-50%, -50%))
        background-color color-23
        color white
        font-size 16px
        border none
        cursor pointer
        border-radius 5px
        text-align center

    .isCareerEntrep
        .btn
            background-color color-green-light
            &:focus
            &:hover
                background-color color-green-dark

</style>
